import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { Card, CardHeader, Container, Skeleton } from '@mui/material';
import api from '../../axios';
import dayjs from 'dayjs';

export default function BasicLineChart() {
  const [ chartData, setChartData ] = React.useState<number[]>([]);
  const [ chartLabels, setChartLabels ] = React.useState<string[]>([]);

  React.useEffect(() => {
    const startDate = dayjs().startOf('day').subtract(2, 'weeks');
    const endDate = dayjs().startOf('day');
    api.post('/dashboard/openitems', {
      startDate,
      endDate,
    })
      .then((res) => {
        console.log(res);
        const { data } = res;
        let tempData = [];
        let tempLabels = [];
        for (let i = 0; i < data.length; i += 1) {
          tempData.push(data[i].count);
          const splitDate = data[i].date.split('-');
          tempLabels.push(splitDate[1]+'/'+splitDate[2]);
        }
        setChartData(tempData);
        setChartLabels(tempLabels);
      })
      .catch(console.error);
  }, []);

  return (
    <Card sx={{ p: 1 }} variant="outlined">
      <CardHeader
        sx={{ position: 'absolute' }}
        subheader={"Number of Unfinished Tasks"}
      />
      {(chartData.length && chartLabels.length) ? (
        <Container sx={{ m: '20px 0 0 10px !important', p: '0 !important' }}>
          <LineChart
            xAxis={[{ scaleType: 'point', data: chartLabels }]}
            series={[
              {
                data: chartData,
                color: 'rgb(85,108,214)',
                area: false,
              },
            ]}
            height={300}
          />
        </Container>
      ) : (
        <Skeleton variant='rounded' height={270} sx={{ mt: '40px' }} width={"100%"} />
      )}
    </Card>
  );
}